import { LatLng } from "leaflet";
import { wgs2jgs } from "@/utils/utils";

interface LatLngCoords {
  lat: number;
  lng: number;
}

/**
 * 指定した座標の地価マップのURLを生成する
 * @param coordinates 座標（日本測地系であること）
 * @return 地価マップのURLを返す、座標がundefinedの場合は地価マップデフォルトの位置のURLを返す
 */
export const generateChikaMapUrl = (coordinates?: LatLng): string => {
  const chikaMapBaseURL = "https://www.chikamap.jp/chikamap/Agreement";
  const chikaMapParams = new URLSearchParams();

  chikaMapParams.append("IsPost", "False");
  chikaMapParams.append("MapId", "324");

  if (coordinates) {
    chikaMapParams.append(
      "RequestPage",
      `/chikamap/Map?mid=325&mpx=${coordinates.lng}&mpy=${coordinates.lat}`
    );
  } else {
    chikaMapParams.append("RequestPage", "/chikamap/Map?mid=325");
  }
  return chikaMapBaseURL + "?" + chikaMapParams.toString();
};

/**
 * 指定した緯度経度（世界測地系）の地価マップのURLを生成する
 * 別のページへ移るものなので、ボタンでなくリンクの href に使う
 * @param latlng 緯度経度（nullの場合はundefinedを返す）
 * @returns 地価マップのURL、またはundefined
 */
export const getChikaMapUrl = (
  latlng: LatLngCoords | null | undefined
): string | undefined => {
  if (!latlng) return undefined;
  const converted = wgs2jgs(new LatLng(latlng.lat, latlng.lng));
  return generateChikaMapUrl(converted);
};
